import React from 'react';
import PropTypes from 'prop-types';

import { useProps, useClassName } from 'components/pure/hooks';

const propTypes = {}
const imutableProps = {}
const mutableProps = {}

const classNames = {
  default: 'rules__group',
}

export default function RulesGroup({ children, className, ...props }) {
  className = useClassName(classNames, className)

  return <div {...useProps(props, imutableProps)} className={className}>
    {children}
  </div>
}

RulesGroup.propTypes = propTypes
RulesGroup.defaultProps = mutableProps

export { default as RulesGroupItemWrapper } from './Item'